import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Rounded, soft-shadow card with tone variants. The default container for
 * sections in the Unify dashboard. Mirrors fresh-dashboard's SoftCard so
 * code can be ported without modification.
 *
 * Tones:
 *   white  — solid white card on the cream background (default)
 *   muted  — near-background card for subtle grouping
 *   accent — indigo-tinted card for "this is important" surfaces
 *   soft   — soft brand-gradient wash for hero blocks
 *
 * Padding is fixed at p-6 / md:p-7. Override via `className` (e.g.
 * `className="!p-0"` for tables that go edge-to-edge).
 */
const TONES = {
	white: 'bg-white',
	muted: 'bg-muted',
	accent: 'bg-accent',
	soft: 'bg-gradient-soft'
};

const SoftCard = React.forwardRef(({ className, tone = 'white', ...props }, ref) => (
	<div
		ref={ref}
		className={cn('rounded-2xl border border-border/60 p-6 md:p-7 shadow-[0_1px_2px_rgba(15,23,42,0.04)]', TONES[tone], className)}
		{...props}
	/>
));
SoftCard.displayName = 'SoftCard';

export { SoftCard };
